import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import { useList } from "store/list";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { getCategories } from "store/core";
import { getCategoriesNew } from "store/core";
import useCanAccess from "hooks/useCanAccess";

export default function Shows() {
  const path = {
    baseRoute: "/show-panel",
    aliasName: "صفحه ها",
    type: "Shows",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  const can = useCanAccess();

  useEffect(() => {
    dispatch(getList(path));
    dispatch(getCategoriesNew("filter[type][$eq]=News"));
    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <Delete
        title="حذف منو"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              handleSuccessMessages("عملیات با موفقیت انجام شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">صفحه ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {can("Show", "createOne") && (
              <Link to="/settings/shows/add">
                <a className="btn btn-primary shadow-md mr-2">ایجاد صفحه</a>
              </Link>
            )}
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {total ? `نمایش ${from} تا ${to} از ${total}` : null}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  {/* <th className="whitespace-nowrap text-center">شناسه</th> */}
                  <th className="whitespace-nowrap text-center">صفحه</th>

                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list?.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list?.length > 0 &&
                  list?.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td className="w-16 text-center">{item?.pageName}</td>

                      <td className="text-center"></td>
                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          {can("Show", "updateOne") && (
                            <Link to={`/settings/shows/edit/${item?.id}`}>
                              <a className="flex items-center ml-3 cursor-pointer">
                                <Icons.CheckSquare className="w-4 h-4 ml-1" />
                                ویرایش
                              </a>
                            </Link>
                          )}
                          {can("Show", "deleteOne") && (
                            <a
                              className="flex items-center text-theme-6 cursor-pointer"
                              onClick={() => {
                                setItem(item);
                                setShowDelete(true);
                              }}
                            >
                              <Icons.Trash2 className="w-4 h-4 ml-1 " />
                              حذف{" "}
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
